<template>
  <b-row>
    <b-col md="6">
      <b-form-group label="VALOR TOTAL DO PEDIDO">
        <b-form-input :value="total.ValorTotalPedidosImpostos" disabled />
      </b-form-group>
    </b-col>
    <b-col md="6">
      <b-form-group label="QUANTIDADE TOTAL">
        <b-form-input :value="quantidade" disabled />
      </b-form-group>
    </b-col>
    <b-col md="6">
      <b-form-group label="TOTAL PESO BRUTO">
        <b-form-input :value="total.PesoBrutoTotal" disabled />
      </b-form-group>
    </b-col>
    <b-col md="6">
      <b-form-group label="TOTAL PESO CUBADO">
        <b-form-input :value="total.PesoCubadoTotal" disabled />
      </b-form-group>
    </b-col>
  </b-row>
</template>
<script>
import { BRow, BCol, BFormGroup, BFormInput } from 'bootstrap-vue';

export default {
  name: 'total-pedido',
  components: { BRow, BCol, BFormGroup, BFormInput },
  computed: {
    total() { return this.$store.getters['PTC_PedidosClient/getTotalPedido'] || {}; },
    quantidade() {
      const value = this.total.QuantidadeTotal;
      if (value == null || value === '') return '';
      const numeric = Number(String(value).replace(',', '.'));
      return Number.isFinite(numeric) ? String(numeric) : 'Não informado';
    },
  },
};
</script>